<template>
<div class="columns fixed-page">
  <div class="column main-column">
    <div class="management-tasks page">
      <div class="management-list-header page-header">
        <div class="flexrow">
          <div class="filler"></div>
          <button-simple
            class="new-button"
            text="New task"
            icon="plus"
            @click="$router.push({
              name: 'production-settings',
              query: { linked: 'management' }
            })"
          />
        </div>
      </div>

      <management-task-list
        :is-loading="isLoading"
        :tasks="taskList"
        :department-filter="departmentFilter"
      />
    </div>
  </div>

  <div
    id="side-column"
    class="column side-column"
    v-show="nbSelectedTasks > 0"
  >
    <task-info
      :task="selectedTasks.values().next().value"
      :singleTask="nbSelectedTasks === 1"
      @task-deleted="updateList()"
    />
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import firstBy from 'thenby'
import { entitiesMixin } from '@/components/mixins/entities'

import ButtonSimple from '@/components/widgets/ButtonSimple'
import ManagementTaskList from '@/components/lists/ManagementTaskList'
import TaskInfo from '@/components/sides/TaskInfo.vue'

export default {
  name: 'management-tasks',
  mixins: [entitiesMixin],

  components: {
    ButtonSimple,
    ManagementTaskList,
    TaskInfo
  },

  data () {
    return {
      taskList: [],
      departmentFilter: [],
      isLoading: true,
    }
  },

  computed: {
    ...mapGetters([
      'currentProduction',
      'currentEpisode',
      'taskTypeMap',
      'selectedTasks',
      'isTVShow',
      'nbSelectedTasks',
      'taskMap',
      'user'
    ])
  },

  methods: {
    ...mapActions([
      'createManagementTask',
      'loadManagementTasks',
      'loadProjectTasks',
      'loadTask'
    ]),

    onNewTaskClick () {
      for (const taskType of this.taskTypeMap.values()) {
        if (taskType.for_entity === 'Management') {
          this.createManagementTask({
            projectId: this.currentProduction.id,
            taskTypeId: taskType.id
          })
        }
      }
    },

    updateList () {
      this.isLoading = true
      this.loadManagementTasks(this.currentProduction.id)
        .then(tasks => {
          var newTaskList = []
          tasks.forEach(task => {
            if (
              !this.isTVShow ||
              (this.currentEpisode.id === 'main' && task.entity_id === null) ||
              this.currentEpisode.id === task.entity_id
            ) {
              this.loadTask({ taskId: task.id })
                .then(() => {
                  newTaskList.push(this.taskMap.get(task.id))
                })
            }
          })
          return newTaskList
        })
        .then(newTaskList => {
          this.taskList = newTaskList.sort(
            firstBy('priority', -1)
              .thenBy((a, b) => {
                const taskTypeA = this.taskTypeMap.get(a.task_type_id)
                const taskTypeB = this.taskTypeMap.get(b.task_type_id)
                return taskTypeA.name.localeCompare(taskTypeB.name)
              })
          )
        })
        .then(() => {
          this.isLoading = false
        })
    }
  },

  mounted () {
    this.applyDepartmentFilter()
    this.updateList()
  },

  metaInfo () {
    return {
      title: `${this.currentProduction.name} | ${this.$t('management.tasks')} - Kitsu`
    }
  },

  watch: {
    $route () {
      this.applyDepartmentFilter()
      this.updateList()
    },

    // currentEpisode() {
    //   this.updateList()
    // },

    taskList() {
      this.applyDepartmentFilter()
    }
  }
}
</script>

<style lang="scss" scoped>
.new-button {
  color: #fff;
  background: #00AA3C;
}
</style>
